module.exports = __webpack_public_path__ + "static/media/house.27d61508.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/house.jpg
// module id = 292
// module chunks = 0